import LocaleRedirect from './LocaleRedirect';

export default LocaleRedirect;
